import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "authReducer",
  initialState: {
    token: {},
    username: "",
    password: "",
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setTokenGenerated: (state, action) => {
      state.token.generatedAt = action.payload;
    },
    setUsernameInStore: (state, action) => {
      state.username = action.payload;
    },
    setPasswordInStore: (state, action) => {
      state.password = action.payload;
    },
  },
});

export const {
  setToken,
  setTokenGenerated,
  setUsernameInStore,
  setPasswordInStore,
} = authSlice.actions;
export default authSlice.reducer;
